import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { Box, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { UniformFlowResult } from "../../types/interfaces/methods";

interface UniformFlowResultsProps {
  calculations: UniformFlowResult[];
}

export default function UniformFlowResults({ calculations }: Readonly<UniformFlowResultsProps>) {
  const { t } = useTranslation();

  const generateRows = () =>
    calculations.map((calc, index) => {
      const r = calc.results;
      return {
        id: index,
        fcuXL: r.fluxoUnifRecarga.fcuXL.toFixed(2),
        fcuYL1: r.fluxoUnifRecarga.fcuYL1.toFixed(2),
        fcuYL2: r.fluxoUnifRecarga.fcuYL2.toFixed(2),
      };
    });

  const columns: GridColDef[] = [
    {
      field: "fcuXL",
      headerName: t("calculations.methods.uniform-flow.results.fcuXL"),
      flex: 1,
    },
    {
      field: "fcuYL1",
      headerName: t("calculations.methods.uniform-flow.results.fcuYL1"),
      flex: 1,
    },
    {
      field: "fcuYL2",
      headerName: t("calculations.methods.uniform-flow.results.fcuYL2"),
      flex: 1,
    },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 3 }}>
        {t("calculations.methods.results-title")}
      </Typography>

      <Box sx={{ mb: 5 }}>
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ fontWeight: 700, mt: 3, mb: 1, display: "flex", alignItems: "center", gap: 1, }}
        >
          <RadioButtonCheckedIcon sx={{ fontSize: 18 }} />
          {t("calculations.methods.uniform-flow.fluxo-unif-recarga")}
        </Typography>

        <DataGrid
          rows={generateRows()}
          columns={columns.map(col => ({ ...col, sortable: false }))}
          hideFooter
          disableColumnMenu
          sx={{
            boxShadow: 1,
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: 1.2,
            },
          }}
        />
      </Box>
    </Box>
  );
}
